export class Country {
  name: string;
  name_fr: string;
  alpha3code: string;
  code: string;
}
